<div class="actions">
	<div class="actions__container">
		<div class="actions__options" *ngIf="isOpenMenu" [@openActionsTable]>
			<div class="actions__options--items">
				<mat-icon
					class="actions__icon"
					style="margin: 0 !important"
					*ngFor="let option of optionsTable"
					(click)="onClickAction(option.value)"
					>{{ option.icon }}</mat-icon
				>
			</div>
		</div>
		<div
			class="actions__icon rotate-180"
			(click)="isOpenMenu = !isOpenMenu"
			[ngClass]="{
				'actions--active': isOpenMenu
			}"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				stroke-width="1.5"
				stroke="currentColor"
				class="w-6 h-6"
			>
				<path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
			</svg>
		</div>
	</div>
</div>
